"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SweetAlertStyles_1 = require("../styles/SweetAlertStyles");
var Content = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { style: SweetAlertStyles_1.contentContainer }, children));
};
exports.default = Content;
//# sourceMappingURL=Content.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-sweetalert/dist/components/Content.js
// module id = 2088
// module chunks = 0